<script>
export default {
}
</script>
<template>
<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 100 100"
     preserveAspectRatio="xMidYMid"
     width="200"
     height="130"
     style="display:block;background:#fff;shape-rendering:auto">

  <!-- DOT 1 -->
  <g transform="translate(20 50)">
    <circle cx="0" cy="0" r="6" fill="#31395a">
      <animateTransform attributeName="transform"
                        type="scale"
                        values="0.25;1;0.25"
                        keyTimes="0;0.5;1"
                        dur="1.2s"
                        repeatCount="indefinite"
                        begin="0s" />
    </circle>
  </g>

  <!-- DOT 2 -->
  <g transform="translate(40 50)">
    <circle cx="0" cy="0" r="6" fill="#1d2031">
      <animateTransform attributeName="transform"
                        type="scale"
                        values="0.25;1;0.25"
                        keyTimes="0;0.5;1"
                        dur="1.2s"
                        repeatCount="indefinite"
                        begin="0.15s" />
    </circle>
  </g>

  <!-- DOT 3 -->
  <g transform="translate(60 50)">
    <circle cx="0" cy="0" r="6" fill="#5c607e">
      <animateTransform attributeName="transform"
                        type="scale"
                        values="0.25;1;0.25"
                        keyTimes="0;0.5;1"
                        dur="1.2s"
                        repeatCount="indefinite"
                        begin="0.30s" />
    </circle>
  </g>

  <!-- DOT 4 -->
  <g transform="translate(80 50)">
    <circle cx="0" cy="0" r="6" fill="#a8a4b9">
      <animateTransform attributeName="transform"
                        type="scale"
                        values="0.25;1;0.25"
                        keyTimes="0;0.5;1"
                        dur="1.2s"
                        repeatCount="indefinite"
                        begin="0.45s" />
    </circle>
  </g>

</svg>

</template>

<style scoped>

</style>